/**
 * Base interface for destination adapters
 * All destination adapters must implement this interface
 */
class DestinationAdapter {
  /**
   * Get adapter name (e.g., "GA4", "META_PIXEL")
   * @returns {string}
   */
  get name() {
    throw new Error('Adapter must implement name getter');
  }

  /**
   * Check if destination SDK is loaded and ready
   * @returns {boolean}
   */
  isInitialized() {
    throw new Error('Adapter must implement isInitialized()');
  }

  /**
   * Initialize destination SDK with credentials
   * @param {Object} credentials - Destination-specific credentials
   * @returns {Promise<boolean>} - True if initialization successful
   */
  async initialize(credentials) {
    throw new Error('Adapter must implement initialize()');
  }

  /**
   * Fire event to destination
   * @param {string} eventKey - Canonical event key
   * @param {Object} eventDef - Full event definition (for adapter-specific enrichment e.g. eventLabel)
   * @param {Object} params - Base event parameters from params-generator
   * @returns {void}
   */
  fireEvent(eventKey, eventDef, params) {
    throw new Error('Adapter must implement fireEvent()');
  }
}

export { DestinationAdapter };
